/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Columns(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25 5.25)">
        <path
          d="M4.75 0.75V12.75M8.75 0.75V12.75M0.75 1.41667C0.75 1.23986 0.820238 1.07029 0.945262 0.945262C1.07029 0.820238 1.23986 0.75 1.41667 0.75H12.0833C12.2601 0.75 12.4297 0.820238 12.5547 0.945262C12.6798 1.07029 12.75 1.23986 12.75 1.41667V12.0833C12.75 12.2601 12.6798 12.4297 12.5547 12.5547C12.4297 12.6798 12.2601 12.75 12.0833 12.75H1.41667C1.23986 12.75 1.07029 12.6798 0.945262 12.5547C0.820238 12.4297 0.75 12.2601 0.75 12.0833V1.41667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

Columns.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Columns
